import type { FaireProductEntity } from "../../entity_types/product";

export const p_ptyry7d2yg: FaireProductEntity = {
  token: "p_ptyry7d2yg",
  type: "product",
  name: "Amber & Moss– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/44e9ff2fd0652c1e1f7bf07374e6bac67ffd1b1a180fcac8b7e980ae98416d77.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f92023dba50b8356baf4f54588224a43562f6d3805c4baf887571abbc9498d66.jpeg",
    "https://cdn.faire.com/fastly/0a5489dc3d72848f40214abbf662396a4c3e9502e93c8742241791639891fce8.jpeg",
    "https://cdn.faire.com/fastly/7db6da13d71f41d5c928fcedb4a60e66e1621a524804c5430c329648fb69578f.jpeg",
    "https://cdn.faire.com/fastly/f6319a0fde047f161bc7b73658c83bc6f2df30102cf5c3ee0c4416a362c9172e.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "A weekend in the mountains, sun gleaming through the canopy. Sage, moss, and lavender.\n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:54.082Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
